// extracted by mini-css-extract-plugin
module.exports = {"title":"a10a3f92e9--title--Pv7aX","filters":"a10a3f92e9--filters--C9bC9"};